import {get, post, put} from '@/api';
import * as PATIENT from '../constants/patient';
import queryString from "query-string";
import * as APPOINTMENT from "@/store/constants/appointment";

export default {
  /**
   * Patient list.
   *
   * @param commit
   * @param param
   * @returns {PromiseLike<T> | Promise<T> | *}
   */
  [PATIENT.ACTION_LIST_PATIENTS]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    const result = get(`/patient?${qs}`);

    result.then((res) => {
      commit(PATIENT.MUTATE_LIST_PATIENT, res.data);
    });

    return result;
  },

  /**
   * Get patient.
   *
   * @param commit
   * @param id
   * @returns {*}
   */
  [PATIENT.ACTION_GET_PATIENT]: ({commit}, id) => {
    const promiseResult = get(`/patient/${id}`);

    promiseResult.then((res) => {
      commit(PATIENT.MUTATE_PATIENT, res.data);
    });

    return promiseResult;
  },

  /**
   * Add patient
   *
   * @param commit
   * @param payload
   * @returns {*}
   */
  [PATIENT.ACTION_ADD]: ({commit}, payload) => {
    return post(`/patient`, payload);
  },

  /**
   * Edit patient.
   *
   * @param commit
   * @param id
   * @param payload
   * @returns {*}
   */
  [PATIENT.ACTION_EDIT]: ({commit}, {id, payload}) => {
    return put(`/patient/${id}`, payload);
  },

  /**
   * Trend
   * @param commit
   * @param payload
   * @returns {*}
   */
  [PATIENT.ACTION_TREND]: ({commit}, payload) => {
    const qs = queryString.stringify(payload);
    return get(`/patient/trend?${qs}`);
  },

  [PATIENT.ACTION_AGGREGATE]: ({commit}, payload) => {
    const qs = queryString.stringify(payload, {arrayFormat: 'bracket'});
    return get(`/patient/aggregate?${qs}`);
  }
}



// WEBPACK FOOTER //
// ./src/store/patient/actions.js